var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6216 0.858886C19.514 0.858886 25.1216 6.46651 25.1216 13.3589C25.1216 20.2513 19.514 25.8589 12.6216 25.8589C5.72921 25.8589 0.121583 20.2513 0.121583 13.3589C0.121584 6.46651 5.72752 0.858885 12.6216 0.858886ZM12.6216 25.0114C19.047 25.0114 24.2741 19.7843 24.2741 13.3589C24.2741 6.93346 19.047 1.70634 12.6216 1.70634C6.19616 1.70634 0.969042 6.93346 0.969041 13.3589C0.96904 19.7843 6.19616 25.0114 12.6216 25.0114Z",
    fill: "#4A831E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1656 9.38636L14.7632 9.98721L11.3717 13.3655L14.7698 16.8778L14.1607 17.467L10.1816 13.3539L14.1656 9.38636Z",
    fill: "#4A831E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.118f957c75db410ff69899a2d9fae3c5.svg";
export { ForwardRef as ReactComponent };